import React from "react"
import {
  listEventsContainer,
  listEventsTitle,
  eventsContainer,
  allEvents,
} from "./agenda.module.scss"
import RenderEvenements from "./RenderEvenements/render-evenements"
import { Title } from "./agenda-styled"
import ContentTransformer from "../../Transformers/content-transformer"
import TransitionFade from "../../transition-fade"
import { useAgendaEvent } from "./agenda-query"

//-----------------------Parent component---------------------------//

function isDateStillValid(currentDate, dateValue) {
  const modifiedDate = dateValue.split("/").reverse().join("-")
  const formattedDate = new Date(modifiedDate)
  if (formattedDate < currentDate) {
    return false
  }
  return true
}

const AgendaEvenements = () => {
  const data = useAgendaEvent()
  const date = new Date()
  let incomingEvents = data.allNodeEvenements.edges.filter(({ node }) => {
    if (node.field_date_de_fin !== null) {
      return isDateStillValid(date, node.field_date_de_fin)
    }
    return isDateStillValid(date, node.field_date_de_debut)
  })
  if (incomingEvents.length === 0) {
    if (data.allNodeEvenements.edges.length === 0) {
      return null
    }
    incomingEvents = data.allNodeEvenements.edges
  }
  return (
    <div className={listEventsContainer}>
      <Title className={listEventsTitle}>
        {data.taxonomyTermZoneDefinie.field_label || "Évènements"}
      </Title>
      {data.taxonomyTermZoneDefinie.description && (
        <ContentTransformer
          content={data.taxonomyTermZoneDefinie.description.processed}
        ></ContentTransformer>
      )}
      <div className={eventsContainer}>
        <RenderEvenements eventsData={incomingEvents} />
      </div>
      <div className={allEvents}>
        <TransitionFade className="btn" link="/evenements">
          Tous les événements
        </TransitionFade>
      </div>
    </div>
  )
}

//-----------------------Parent component---------------------------//

export default AgendaEvenements
